import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Output,
  EventEmitter,
  HostListener,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { scheduler } from '../../../../../../../../../dhtmlx-scheduler';
import { EventService, getBrandDefaults } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { scheduled, Subject, BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FetchJdeOrder } from '../orders/+state/orders.actions';
import { Store, select } from '@ngrx/store';
import { CustomersPartialState } from '../customers/+state/customers.reducer';
import {
  OrderArray,
  ResourceList,
  TaskArray,
  ListWorkshopTasks,
  ListWorkshopVehicleStatus,
  ListWorkshopJobTypes,
  Legend,
  JobOrder,
} from '@pos-app/data';
import { getBranch, CoreUiPartialState } from '@pos-app/core-ui';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import moment from 'moment';
import {
  get_formatted_duration,
  getSplitLine,
  convert,
  schedulerAppValue,
  getformatedDate,
  getformatedTime,
  getEventColorFromListWorkshopTask,
  getformatedTimeForZones,
  getInMinutes,
  timeToMinutes,
  getnth,
  getformatedTimeHHMM,
  getListWorkshopJobTypesFormattedWithKey,
  allUnallocateSectionID,
} from './scheduler-helper';
import { checkInBreakRange, breaksFallBetweenEvent } from './schedulerBreak-helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalResourceContent } from './resource/resource.component';
import { UntypedFormGroup, UntypedFormControl, Validators, NgModel } from '@angular/forms';
import { SplitOrderContent } from './splitorder/splitorder.component';
import { ConfirmationService } from 'primeng/api';
import { NgbdModalOrderDetailCard } from './orderDetailCard/orderDetailCard.component';
import { NgbdModalTaskDetailCard } from './taskDetailCard/taskDetailCard.component';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SchedulerSetWorkshopDays } from './workshop/schedulerDays/schedulerSetWorkshopDays.component';
import { SchedulerSetWorkshopHours } from './workshop/schedulerHours/schedulerSetWorkshopHours.component';
import {SpinnerService} from '@pos-app/core-ui';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-scheduler',
    styleUrls: ['./scheduler.component.css'],
    templateUrl: './scheduler.component.html',
    standalone: false
})
export class SchedulerComponent implements OnInit, OnDestroy {
  @ViewChild('scheduler_here', { static: true }) schedulerContainer!: ElementRef;
  @ViewChild('content') modalBox: any;

  @Output() onFetchOrderFromJDE = new EventEmitter();
  unSubscribe$ = new Subject<void>();
  year: number = this.route.snapshot.params.year;
  month: number = this.route.snapshot.params.month;
  day: number = this.route.snapshot.params.day;
  viewType: string = this.route.snapshot.params.viewType;
  defaultBranch: string;
  currentStartDate: string;
  currentDate: string;
  previousDate: string;
  currentEventData: any;
  currentTaskData: any;
  clicked: Boolean = false;
  resourceList: ResourceList[];
  previousTechnicianID: number;
  globalStart: string;
  globalEnd: string;
  previousGlobalDate: string;
  nextGlobalDate: string;
  listWorkshopTasks: ListWorkshopTasks[];
  orderArray: OrderArray[];
  taskArray: TaskArray[];
  technician: ResourceList[];
  unAllocatedOrders: OrderArray[];
  unAllocatedFloater: OrderArray[];
  orderViewLightbox: any;
  eventViewLightbox: any;
  newScheduledHrs: number;
  previousTechnicianIDData: any;
  listWorkshopVehicleStatus: ListWorkshopVehicleStatus[];
  listWorkshopJobTypes: ListWorkshopJobTypes[];
  otherResources: ResourceList[];
  searchOrderForm: UntypedFormGroup;
  validSearch: boolean = false;
  globalData: ResourceList;
  availableResources: ResourceList;
  customFunctionLoaded: boolean = false;
  showingContextMenu: boolean = false;
  floaterToggleState: boolean = false;
  salesTogglestate: boolean = false;
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean>;
  showSMS: boolean = false;
  workshopLegend: Legend;
  isLegendView: boolean = false;
  isOrderDetailsCardView: boolean = false;
  isEventCollision: boolean = false;
  jobTypeLegend: Legend[];
  vehicleStatusLegend: Legend[];
  customerTypeLegend: Legend[];
  orderDetailCardLoaded: boolean = false;
  taskDetailCardLoaded: boolean = false;
  searchOrderStatus: boolean = false;
  forwardDirection: boolean = true;
  currentMonth: number;
  brandDefaults: any;
  constructor(
    private eventService: EventService,
    private customerStore: Store<CustomersPartialState>,
    private coreUIStore: Store<CoreUiPartialState>,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private confirmationService: ConfirmationService,
    private router: Router,
    public spinnerService: SpinnerService
  ) {}

    ngAfterConstructor(): void {
      // placeholder if needed
    }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    scheduler.config.tooltip_offset_y = -window.scrollY;
  }
  @HostListener('document:click', ['$event']) click($event) {
    if (this.customFunctionLoaded) {
      scheduler?.removeContextMenu();
      this.showingContextMenu = false;
    }
  }

  ngOnInit() {
    // combine global spinner state with local loading subject
    this.loading$ = combineLatest([this.spinnerService.loading$, this.loadingSubject.asObservable()]).pipe(map(([global, local]) => global || local));
    if (!localStorage.getItem('preload')) {
      localStorage.setItem('preload', 'preloaded');
      this.loadingSubject.next(true);
      location.reload();
    } else {
      this.loadingSubject.next(false);
      localStorage.removeItem('preload');
    }

    this.getBranchInfo();
    this.getViewStatus();
    this.getStartDate();
    if (this.viewType === 'timeline') {
      this.fetchWorkshopTaskList().then((data: any) => {
        if (data) {
          this.listWorkshopTasks = data?.SearchResults;
          this.fetchWorkshopJobType().then((data: ListWorkshopJobTypes) => {
            if (data) {
              this.listWorkshopJobTypes = getListWorkshopJobTypesFormattedWithKey(data?.SearchResults);
              this.getListWorkshopVehicleStatus().then((value: any) => {
                this.listWorkshopVehicleStatus = value?.SearchResults;
                this.loadTimelineScheduler(this.currentDate);
              });
            }
          });
        }
      });
      this.searchOrderForm = new UntypedFormGroup({
        orderNumber: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(3)]),
        jobId: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1)]),
      });
    }
  }

  loadTimelineScheduler(date: string) {
    this.loadingSubject.next(true);
    this.fetchWorkshopHours(date).then((data: any) => {
      if (data) {
        this.globalStart = data[0]?.globalStartTime;
        this.globalEnd = data[0]?.globalFinishTime;
        this.previousGlobalDate = data[0]?.previousDate;
        this.nextGlobalDate = data[0]?.nextDate;
        this.setCalendarNavButton(data[0]?.previousDate, data[0]?.nextDate);
        this.globalData = data[0]?.resourceArray[0];
        this.resourceList = data[0]?.resourceArray.splice(1, data[0]?.resourceArray.length);
        this.currentDate = date;
        if (Number(data[0]?.globalFinishTime) !== 0 && Number(data[0]?.globalStartTime) !== 0) {
          this.fetchRecords().then((data: any) => {
            this.orderArray = data?.orderArray;
            this.taskArray = data?.taskArray;
            this.unAllocatedOrders = data?.orderArray
              ?.filter((el) => el.ResourceAssigned === '')
              .map((data, index) => ({
                key: data?.ResourceAssigned ? parseInt(data?.ResourceAssigned, 10) : index + 1,
                label: data?.OrderNumber,
                data: data,
              }));
            this.loadDataToTimelineScheduler(this);
            this.loadingSubject.next(false);
            this.checkIfShowOrdeDetails();
          });
        } else if (this.forwardDirection && data[0]?.nextDate) {
          this.loadTimelineScheduler(data[0]?.nextDate);
          this.loadingSubject.next(false);
        } else if (!this.forwardDirection && data[0]?.nextDate) {
          this.loadTimelineScheduler(data[0]?.previousDate);
          this.loadingSubject.next(false);
        } else {
          this.loadingSubject.next(false);
          this.confirmationService.confirm({
            message: 'DATE OUT OF SCHEDULER SCOPE ',
            key: 'goToDateResult',
            accept: () => {
              scheduler.clearAll();
              this.loadTimelineScheduler(this.day.toString() + '/' + this.month.toString() + '/' + this.year.toString());
            },
          });
        }
      }
    });
    //=========================================================================================
    //Initialize plugins
    //=========================================================================================
  }
  loadDataToTimelineScheduler(context: any) {
    if (!(scheduler as any).$_initOnce) {
      (scheduler as any).$_initOnce = true;
      this.addPlugin();
      this.addConfig();
      this.addLabels();
      this.addEventBar();
      this.addLightBox();
      this.addworkshopSchedulerEvent(this);
      this.addCustomWorkshopSchedulerEvent(this);
      this.addworkshopSchedulerTemplates(this);
      this.addTimelineView();
      const dp = scheduler.createDataProcessor({
        event: {
          create: (data: any) => {
            console.log('create', data?.id);
          },
          update: (data: any) => {
            console.log('update', data);
          },
          delete: (id: number) => {
            console.log('deleted', id);
          },
        },
      });
      dp.attachEvent('onBeforeDataSending', function (id, state, data) {
        let resourceIDList;
        if (allUnallocateSectionID.some((el) => el === data.section_id)) {
          resourceIDList = [];
        } else {
          resourceIDList = scheduler.getResourceList(
            data?.section_id?.toString().indexOf(',') > 0
              ? data?.section_id?.split(',').map(function (n) {
                  return Number(n);
                })
              : [data?.section_id],
            context.previousTechnicianIDData
          );
        }
        if (
          data?.keyCode &&
          (state === 'inserted' || state === 'updated') &&
          id &&
          data
          //  &&
          // !allUnallocateSectionID.some((el) => el === data.section_id)
        ) {
          const dataToCreateOrUpdate = {
            startDate: convert(data?.start_date),
            endDate: convert(data?.end_date),
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            branch: context.defaultBranch,
            jobID: state === 'inserted' ? 0 : data?.data?.JobID,
            taskCode: data?.keyCode,
            description: data?.text,
            scheduledHours: context.newScheduledHrs,
            resources: resourceIDList,
            jobOwner: state === 'inserted' ? '' : data?.data?.JobOwner,
          };
          scheduler.customCreateOrUpdateEvent(dataToCreateOrUpdate, 0, state);
          return true;
        } else if (data.keyCode && state === 'deleted' && id && data && !allUnallocateSectionID.some((el) => el === data.section_id)) {
          const dataToDelete = {
            jobID: data?.data?.JobID,
            startDate: data?.data?.WorkshopStartDate,
            endDate: data?.data?.WorkshopEndDate,
            startTime: data?.data?.WorkshopStartTime,
            endTime: data?.data?.WorkshopEndTime,
            description: data?.data?.TaskDescription,
            scheduledHours: data?.data?.ScheduledHours,
            branch: context.defaultBranch,
            taskCode: data?.keyCode,
            resources: [],
          };
          scheduler.customDeleteEvent(id, dataToDelete);
          return true;
        } else if (!data.keyCode && state === 'updated' && !allUnallocateSectionID.some((el) => el === data.section_id)) {
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: data?.data?.JobID,
            scheduledHours: context.newScheduledHrs ?? Number(data?.allocatedHours) + Number(data?.extraHours),
            orderNumber: data?.data?.OrderNumber,
            orderType: data?.data?.OrderType,
            description: data?.description ?? data?.data?.Description,
            resources: resourceIDList,
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            startDate: context?.currentDate, //convert(data?.start_date),
            endDate: context?.currentDate, //convert(data?.end_date),
            jobTypeCode: data?.key,
            vehicleStatusCode: data?.data?.VehicleStatusCode ?? '00',
            jobOwner: data?.data?.JobOwner ?? '',
          };
          scheduler.customUpdateOrder(orderDataToUpdate);
          return true;
        } else if (!data.keyCode && state === 'updated' && allUnallocateSectionID.some((el) => el === data.section_id)) {
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: data?.data?.JobID,
            status: data?.data?.status ?? 10,
            scheduledHours: context.newScheduledHrs,
            orderNumber: data?.data?.OrderNumber,
            orderType: data?.data?.OrderType,
            description: data?.data.Description,
            resources: resourceIDList,
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            startDate: context?.currentDate, //convert(data?.start_date),
            endDate: context?.currentDate, //convert(data?.end_date),
          };
          scheduler.customUpdateOrder(orderDataToUpdate);
          return true;
        } else {
          return false;
        }
      });
    }

    scheduler.deleteMarkedTimespan();
    let configObj = scheduler.matrix;
    let diffStartHours = moment
      .duration(moment(getformatedTime(this.globalEnd.toString()), 'HH:mm:ss').diff(moment(getformatedTime(this.globalStart.toString()), 'HH:mm:ss')))
      .asHours();
    configObj.timeline.x_size = diffStartHours * 2;
    configObj.timeline.x_start = (getInMinutes(Number(this.globalStart)) / 60) * 2;
    const nth = getnth(this.currentDate.split('/')[0]);
    let formatDayDate = scheduler.date.date_to_str(`%l, %j${nth} of %F`);
    scheduler.templates.day_date = function (date) {
      return formatDayDate(date);
    };
    scheduler.updateView(
      new Date(Number(this.currentDate.split('/')[2]), Number(this.currentDate.split('/')[1]) - 1, Number(this.currentDate.split('/')[0]))
    );
    this.addTechnicianToTimeline();
    this.addMarkedTimespan();
    this.addOrderToTimeline(this.globalStart);
    this.addTaskToTimeline();
  }
  //internal function
  getBranchInfo() {
    this.coreUIStore.pipe(takeUntil(this.unSubscribe$), select(getBranch)).subscribe((x) => {
      this.defaultBranch = x?.BranchCode;
    });
    this.coreUIStore
      .select(getBrandDefaults)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.brandDefaults = data;
      });
  }
  getViewStatus() {
    this.viewType = 'timeline';
  }
  getStartDate() {
    this.currentDate = this.day.toString() + '/' + this.month.toString() + '/' + this.year.toString();
  }
  getTechnicianData() {
    return this.technician;
  }
  //scheduler function
  addPlugin() {
    scheduler.plugins({
      timeline: true,
      treetimeline: true,
      editors: true,
      tooltip: true,
      limit: true,
      multiselect: true,
      multisection: true,
      collision: true,
    });
  }
  addConfig() {
    //=========================================================================================
    // config
    //=========================================================================================
    scheduler.config.details_on_create = true;
    scheduler.config.details_on_dblclick = true;
    scheduler.config.buttons_right = ['dhx_delete_btn'];
    scheduler.config.multisection = true;
    scheduler.config.show_loading = true;
  }
  addLabels() {
    //=========================================================================================
    //scheduler.locale.labels
    //=========================================================================================
    //-----------------------------------
    //main
    //------------------------------------
    scheduler.locale.labels['timeline_tab'] = 'Timeline';
    scheduler.locale.labels['section_custom'] = 'Section';
    scheduler.locale.labels['unit_tab'] = 'Unit';
    //-----------------------------------
    //Common lighbox labels
    //-----------------------------------
    scheduler.locale.labels['section_customer'] = 'Customer :';
    scheduler.locale.labels['section_order'] = 'Order :';
    scheduler.locale.labels['section_vehicle'] = 'Vehicle :';
    scheduler.locale.labels['copy_button'] = 'Copy';
    scheduler.locale.labels['section_allocatedHours'] = 'Allocated Hours :';
    scheduler.locale.labels['section_extraHours'] = 'Extra Hrs:';
    scheduler.locale.labels['section_groupName'] = 'Group Name:';
    scheduler.locale.labels['section_attachment'] = 'Attachments';
    // scheduler.locale.labels['section_wholeDayWorkYN'] = 'Whole Day';
    //-----------------------------------
    //Unallocated order lighbox labels
    //-----------------------------------

    scheduler.locale.labels['dhx_save_btn'] = 'SAVE';
    scheduler.locale.labels['dhx_cancel_btn'] = 'CANCEL';
    //-----------------------------------
    //Allocated order lighbox labels
    //-----------------------------------
    scheduler.locale.labels['section_technician'] = 'Technician';
    scheduler.locale.labels['section_technicianSelect'] = 'Select More Technician';
  }
  addEventBar() {
    //=========================================================================================
    //Custom Formatting Event Bar
    //=========================================================================================
    const resize_date_format = scheduler.date.date_to_str(scheduler.config.hour_date);
    scheduler.templates.event_bar_text = function (start, end, event) {
      const state = scheduler.getState();
      const lines = getSplitLine(event.text.toString());
      if (state.drag_id == event.id) {
        return resize_date_format(start) + ' - ' + resize_date_format(end) + ' (' + get_formatted_duration(start, end) + ') ';
        // | Extra Hrs:" +extra
      }
      // const barFontColourCode = scheduler.getBarFontColourCode(event.data?.StatusGroup, event.data?.Status, true);
      // const barBackgroundColourCode = scheduler.getBarBackgroundColourCode(event.data?.StatusGroup, event.data?.Status, true);
      // const barUnallocateFontColourCode = scheduler.getBarFontColourCode(event.data?.StatusGroup, event.data?.Status, false);
      // const barUnallocateBackgroundColourCode = scheduler.getBarBackgroundColourCode(event.data?.StatusGroup, event.data?.Status, false);
      let bar_partition = ''; //event.text;
      if (allUnallocateSectionID.some((el) => el === event.section_id) === false) {
        const hoursWithbreak = moment.duration(moment(event.end_date, 'HH:mm').diff(moment(event.start_date, 'HH:mm'))).asHours();
        const breakHours = hoursWithbreak - event?.data?.StandardFitHours - (event?.data?.ScheduledHours - event.data?.StandardFitHours);

        if (event.data?.StandardFitHours || event.data?.StandardFitHours === 0) {
          const adjustedHours = Math.round(Math.abs(event?.data?.ScheduledHours - event.data?.StandardFitHours) * 100) / 100;
          const extraHours = event?.data?.ScheduledHours - event.data?.StandardFitHours;
          bar_partition += `
          <div style="position: relative; 
                      border-top: 3px solid; 
                      border-color:#${event?.data?.BorderColour};
                      padding: 0px; 
                      width:${2 * scheduler._cols[0] * hoursWithbreak}px; 
                      height: 28px; 
                      overflow: hidden;
                      z-index: -1;
                      margin-left:-12px;
                      margin-right:-14px
                      ">
            <div style="position: absolute; 
                      top: 0; 
                      bottom: 0; 
                      width:${2 * scheduler._cols[0] * (event?.data?.StandardFitHours + breakHours)}px;
                      background-color: #${event?.data?.BackgroundColour};
                      ">
            </div>
            ${
              extraHours > 0
                ? `
               <div style="position: absolute; top: 0; bottom: 0;  width:${
                 2 * scheduler._cols[0] * (extraHours > 0 ? extraHours : 1)
               }px;  background-color: #8a605c; right: 0; z-index: -1;"></div>
              `
                : ``
            }
            <div style="position: absolute; 
                        left: 10px; 
                        top: 50%; 
                        transform: translateY(-50%); 
                        white-space: nowrap; 
                        overflow: hidden; 
                        text-overflow: ellipsis; 
                        max-width: calc(100% - 60px);
                        ">
               ${event.text} ${adjustedHours ? '| ' + adjustedHours + ' Hrs Adjusted' : ''}
            </div> 
            <div style="position: absolute; 
                        right: 0px; 
                        top: 50%;
                        padding:6px;
                        transform: translateY(-50%);
                        white-space: nowrap;
                        
                        ${extraHours > 0 ? `background-color:#8a605c` : `background-colour:${event?.data?.BackgroundColour}`}
                        ">
          ${extraHours > 0 ? `| &nbsp;&nbsp;${Math.round(Math.abs(extraHours) * 100) / 100} : Extra Hrs &nbsp;` : ``}${
            event.data.JobSplitText
          }&nbsp;&nbsp;
            </div>
          </div>
              `;
        } else {
          bar_partition += '<div>&nbsp;&nbsp;' + event.text + '</div>';
        }

        return bar_partition;
      } else {
        return `<div style="position: relative; 
                      border-top: 3px solid; 
                      border-color:#${event?.data?.BorderColour};
                      padding: 0px; 
                      width:${2 * scheduler._cols[0] * (event?.data?.ScheduledHours < 1 ? 1 : event?.data?.ScheduledHours)}px;
                      height: ${
                        (event?.filteredSalesOrdersSize === 1 && event.section_id === schedulerAppValue.unAllocatedSalesOrder_SectionId_child) ||
                        (event?.filteredOrdersFloaterSize === 1 && event.section_id === schedulerAppValue.unAllocatedFloater_SectionId_child)
                          ? `28px;`
                          : `22px;`
                      }
                      overflow: hidden;
                      z-index: -1;
                      margin-left:-12px;
                      margin-right:-14px
                      ">
                  <div style="position: absolute; 
                              top: 0; 
                              bottom: 0; 
                              width:${2 * scheduler._cols[0] * (event?.data?.ScheduledHours < 1 ? 1 : event?.data?.ScheduledHours)}px;
                              background-color: #${event?.data?.BackgroundColour};
                            ">
                  </div>
                  
                  <div style="position: absolute; 
                              left: 10px; 
                              top: 50%; 
                              transform: translateY(-50%); 
                              white-space: nowrap; 
                              overflow: hidden; 
                              text-overflow: ellipsis; 
                              max-width: calc(100% - 60px);
                              ">
                      ${event.text} 
                  </div> 
                  <div style="position: absolute; 
                              right: 0px; 
                              top: 50%;
                              transform: translateY(-50%);
                              white-space: nowrap;
                            
                              ">
                ${event.data.JobSplitText}&nbsp;&nbsp;
                  </div>
          </div>`;
      }
    };
  }
  addTimelineView() {
    //=========================================================================================
    //TimeLineView
    //=========================================================================================
    scheduler.createTimelineView({
      section_autoheight: false,
      name: 'timeline',
      x_unit: 'minute',
      x_date: '%H:%i',
      x_step: 30,
      x_size: getInMinutes(Number(this.globalEnd)) / 60,
      x_start: (getInMinutes(Number(this.globalStart)) / 60) * 2,
      x_length: 48,
      y_unit: scheduler.serverList('sections', []),
      y_property: 'section_id',
      render: 'tree',
      folder_events_available: true,
      dy: 30,
      dx: 250,
      event_dy: 30,
      scrollable: true,
    });
    scheduler.config.default_date = `%l, %j${getnth(this.day)} of %F`;
    scheduler.config.hour_size_px = 84;
    scheduler.config.full_day = true;
    scheduler.config.prevent_cache = true;
    scheduler.xy.scroll_width = 10;
    scheduler.init(this.schedulerContainer.nativeElement, new Date(this.year, this.month - 1, this.day), 'timeline');
  }
  addLightBox() {
    //=========================================================================================
    //Common Event Ligthbox setup
    //=========================================================================================

    this.eventViewLightbox = [
      {
        name: 'Type',
        type: 'select',
        options: scheduler.serverList('listworkshopTasks', this.listWorkshopTasks),
        map_to: 'key',
      },

      { name: 'description', height: 50, map_to: 'text', type: 'textarea', focus: true },
      {
        name: 'technician',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('technician'),
        map_to: 'technician_id',
        vertical: true,
      },

      {
        name: 'Other Resources',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('otherResources'),
        map_to: 'otherResources_id',
        vertical: true,
      },
      { name: 'time', height: 72, type: 'time', map_to: 'auto' },

      // { name: 'wholeDayWorkYN', map_to: 'single_checkbox', type: 'checkbox', checked_value: 'wholeDay', height: 40 },
    ];

    //=========================================================================================
    //Order Event Ligthbox setup
    //=========================================================================================
    this.orderViewLightbox = [
      { name: 'order', height: 20, type: 'template', map_to: 'orderNumber', id: 'orderNumber' },
      { name: 'customer', height: 20, type: 'template', map_to: 'customer' },
      { name: 'vehicle', height: 20, type: 'template', map_to: 'vehicle' },
      {
        name: 'Job Type',
        type: 'select',
        options: scheduler.serverList('listworkshopJobTypes', this.listWorkshopJobTypes),
        map_to: 'key',
      },
      { name: 'description', height: 40, map_to: 'description', type: 'textarea', focus: false },
      {
        name: 'technician',
        height: 350,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('technician'),
        map_to: 'technician_id',
        vertical: true,
      },
      {
        name: 'Other Resources',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('otherResources'),
        map_to: 'otherResources_id',
        vertical: true,
      },
      { name: 'time', height: 72, type: 'time', map_to: 'auto' },
      { name: 'allocatedHours', height: 20, type: 'template', map_to: 'allocatedHours' },
      { name: 'extraHours', height: 20, type: 'template', map_to: 'extraHours' },
      { name: 'attachment', height: 60, type: 'template', map_to: 'my_templete' },
    ];
  }
  addworkshopSchedulerEvent(context) {
    let parent_select_options = scheduler.serverList('technician');
    let child_select_options = { '0000': scheduler.serverList('technician') };
    let update_select_options = function (select, options) {
      // helper function
      if (options) {
        for (let i = 0; i < options.length; i++) {
          select.section.options[i] = new Option(options[i].key, options[i].label);
        }
      }
    };
    let parent_select_options2 = scheduler.serverList('otherResources');
    let child_select_options2 = { '0000': scheduler.serverList('otherResources') };
    let update_select_options2 = function (select, options) {
      // helper function
      if (options) {
        for (let i = 0; i < options.length; i++) {
          select.section.options[i] = new Option(options[i].key, options[i].label);
        }
      }
    };

    scheduler.attachEvent('onLightboxButton', function (button_id, node, e) {
      if (button_id === 'copy_button') {
        scheduler.endLightbox(false);
        this.btn_copyEvent(button_id, node, e);
      }
    });

    // check if the event collison
    scheduler.attachEvent(
      'onEventCollision',
      (ev, evs) => {
        if (ev.section_id.toString().split(',').length > 1) {
          return false;
        }
        if (allUnallocateSectionID.some((el) => el === ev.section_id) === true) {
          return false;
        } else {
          this.isEventCollision = true;
          return true;
        }
      },
      {}
    );
    scheduler.attachEvent('onBeforeLightbox', function (event_id) {
      scheduler.setNavStatus(true);
      scheduler.resetLightbox();
      const ev = scheduler.getEvent(event_id);
      scheduler.config.event_duration = ev.data?.StandardFitHours * 60;
      scheduler.config.auto_end_date = true;
      const resourceAssigned = ev?.data?.ResourceAssigned.map((el) => el.ResourceID).join(',');
      ev.technician_id = resourceAssigned ?? ev.section_id;
      ev.otherResources_id = resourceAssigned ?? ev.section_id;
      ev.scheduledHours = context.newScheduledHrs;

      if (!ev.child_id) {
        let parent_id = ev.parent_id || parent_select_options[0]?.key;
        let new_child_options = child_select_options[parent_id];
        update_select_options(scheduler.formSection('child'), new_child_options);
        let parent_id2 = ev.parent_id || parent_select_options2[0]?.key;
        let new_child_options2 = child_select_options2[parent_id2];
        update_select_options2(scheduler.formSection('child'), new_child_options2);
      }
      if ((ev?.keyCode || ev?.text === 'New event') && !ev?.data?.OrderNumber) {
        //treat as event
        scheduler.btn_openTaskDetailCard(ev);
        return false;
      } else if ((allUnallocateSectionID.some((el) => el === ev.section_id) || ev?.data?.OrderNumber) && (ev?.text !== 'New event' || !ev?.keyCode)) {
        scheduler.btn_openOrderDetailCard(ev);
      }
      return false;
    });

    scheduler.attachEvent('onLightbox', function (ev) {
      const order = scheduler.formSection('order');
      const time = scheduler.formSection('time');
      const allocatedHours = scheduler.formSection('allocatedHours');
      const extraHours = scheduler.formSection('extraHours');
      const selects = time.node.getElementsByTagName('select');
      for (let i = 0; i < selects.length; i++) {
        selects[i].onchange = function () {
          const addedHours = Math.abs(time?.getValue()?.end_date?.getTime() - time?.getValue()?.start_date?.getTime()) / 3600000;
          if (allocatedHours?.getValue() < addedHours) {
            extraHours?.setValue(addedHours - allocatedHours?.getValue());
          } else {
            extraHours?.setValue(0);
          }
        };
      }
    });

    scheduler.attachEvent('onBeforeViewChange', function (old_mode, old_date, mode, date) {
      if (mode == 'Settings') {
        scheduler.alert({
          text: '',
          title: 'Custom setting needs more work',
          ok: 'OK',
          callback: function () {},
        });

        return false; // prevent view change on custom button click
      } else {
        this.btn_Clicked_onBeforeViewChange(old_date, date);
        return true;
      }
    });

    scheduler.attachEvent('onClick', function (id) {
      let event = scheduler.getEvent(id);
      if (event.important) scheduler.config.icons_select = ['icon_details'];
      else scheduler.config.icons_select = ['icon_details', 'icon_delete'];

      return true;
    });

    //=========================================================================================
    //adding save event
    //=========================================================================================
    scheduler.attachEvent('onEventSave', function (id, ev, is_new) {
      let valid = true;
      const listworkshopTask = context?.listWorkshopTasks.find((el) => el?.key === ev.key);
      ev.keyCode = listworkshopTask?.keyCode;
      let combinedResources;
      if (ev.technician_id && ev.otherResources_id) {
        combinedResources = ev.technician_id + ',' + ev.otherResources_id;
      } else if (ev.technician_id) {
        combinedResources = ev.technician_id;
      } else if (ev.otherResources_id) {
        combinedResources = ev.otherResources_id;
      }
      if (is_new) {
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
        ev.text = listworkshopTask.label + ' : ' + ev.text;
        ev.color = '#' + listworkshopTask.backgroundColourCode;
        ev.scheduledHours = context.newScheduledHrs;
        if (!valid) {
          !ev.text ? scheduler.alert('Description must not be empty') : null;
          !combinedResources ? scheduler.alert('Technician must not be empty') : null;
        }
      } else if (ev.text && ev?.keyCode) {
        ev.scheduledHours = context.newScheduledHrs;
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
      }
      const selectedStartTime = moment(ev.start_date).format('HH:mm');
      const startRangeTime = moment(getformatedTime(context.globalStart.toString()), 'HH:mm');
      let diffStartHours = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).hours();
      let diffStartMinutes = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).minutes();
      let diffTotalStart = diffStartHours + diffStartMinutes / 60;
      const selectedEndTime = moment(ev.end_date).format('HH:mm');
      const endRangeTime = moment(getformatedTime(context.globalEnd.toString()), 'HH:mm');
      let diffEndHours = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).hours();
      let diffEndMinutes = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).minutes();
      let diffTotalEnd = diffEndHours + diffEndMinutes / 60;
      if (moment(ev.start_date).format('HH:mm') === '00:00' && moment(ev.start_date).format('HH:mm') === '00:00') {
        ev.start_date = moment(getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(context.globalStart.toString())).toDate();
        ev.end_date = moment(getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(context.globalEnd.toString())).toDate();
        context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
      } else if (diffTotalStart < 0) {
        // when start time < global start time
        valid = false;
        scheduler.alert('Selected start time exceed working hours of the day');
      } else if (diffTotalEnd > 0) {
        scheduler.alert('Selected end time exceed working hours of the day');
        valid = false;
      } else if (!is_new && ev?.technician_id) {
        const currentOrderData = context.orderArray.filter((el) => el.OrderNumber === Number(ev?.orderNumber));
        context.newScheduledHrs = currentOrderData[0]?.ScheduledHours;
        ev.scheduledHours = currentOrderData[0]?.ScheduledHours;
      }
      if (ev.description && !ev?.keyCode) {
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
      }
      if (!valid) {
        return false;
      } else {
        return true;
      }
    });

    scheduler.attachEvent('onBeforeEventDelete', function (id, ev) {
      if (ev?.data?.OrderNumber > 0) {
        scheduler.alert({
          text: '',
          title: 'Order not allowed to Delete',
          ok: 'OK',
          callback: function () {},
        });
        return false;
      }
      return true;
    });
    //=========================================================================================
    //Triggering method before event change
    //=========================================================================================
    scheduler.attachEvent('onBeforeEventChanged', function (ev, e, is_new, original) {
      let customCheckCollision = false;
      if (allUnallocateSectionID.some((el) => el === ev.section_id) && allUnallocateSectionID.some((el) => el === original.section_id)) {
        return;
      }
      context.newScheduledHrs = scheduler.getScheduledHrs(ev.start_date, ev.end_date);
      let technicianData =
        scheduler.getTechnician()?.filter((el) => el.resourceID === ev.section_id)[0] ||
        scheduler.getOtherResources()?.filter((el) => el.resourceID === ev.section_id)[0];
      let origionalTechnicianData =
        scheduler.getTechnician()?.filter((el) => el.resourceID === original.section_id)[0] ||
        scheduler.getOtherResources()?.filter((el) => el.resourceID === original.section_id)[0];
      if (!technicianData) {
        technicianData = scheduler.getOtherResources()?.filter((el) => el.resourceID === ev.section_id)[0];
      }
      let condition = [];
      if (!is_new && !allUnallocateSectionID.some((el) => el === ev.section_id)) {
        context.previousTechnicianIDData = original;

        // if (
        //   (ev.start_date.getTime() === original.start_date.getTime() || ev.end_date.getTime() === original.end_date.getTime()) &&
        //   ev.section_id === original.section_id
        // ) {
        //   context.newScheduledHrs = scheduler.getScheduledHrs(ev.start_date, ev.end_date);
        //   const selectedStartTime = moment(ev.start_date).format('HH:mm');
        //   const startRangeTime = moment(getformatedTime(technicianData.startTime.toString()), 'HH:mm');
        //   let diffStartHours = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).hours();
        //   let diffStartMinutes = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).minutes();
        //   let diffTotalStart = diffStartHours + diffStartMinutes / 60;

        //   const selectedEndTime = moment(ev.end_date).format('HH:mm');
        //   const endRangeTime = moment(getformatedTime(technicianData.finishTime.toString()), 'HH:mm');
        //   let diffEndHours = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).hours();
        //   let diffEndMinutes = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).minutes();
        //   let diffTotalEnd = diffEndHours + diffEndMinutes / 60;
        //   const globalStartDateTime = moment(
        //     getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.startTime.toString())
        //   ).toDate();
        //   const globalEndDateTime = moment(
        //     getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.finishTime.toString())
        //   ).toDate();
        //   const maxScheduleHrs = moment.duration(moment(globalEndDateTime, 'HH:mm').diff(moment(technicianData.startTime, 'HH:mm'))).asHours();
        //   if (diffTotalStart < 0) {
        //     ev.start_date = globalStartDateTime;
        //     context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
        //     ev.data['ScheduledHours'] = context.newScheduledHrs;
        //   } else if (diffTotalEnd > 0) {
        //     ev.end_date = globalEndDateTime;
        //     context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
        //     ev.data['ScheduledHours'] = context.newScheduledHrs;
        //   }
        // } else {
        const selectedStartTime = moment(ev.start_date).format('HH:mm');
        const startRangeTime = moment(getformatedTime(technicianData.startTime.toString()), 'HH:mm');
        let diffStartHours = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).hours();
        let diffStartMinutes = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).minutes();
        let diffTotalStart = diffStartHours + diffStartMinutes / 60;

        const selectedEndTime = moment(ev.end_date).format('HH:mm');
        const endRangeTime = moment(getformatedTime(technicianData.finishTime.toString()), 'HH:mm');
        let diffEndHours = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).hours();
        let diffEndMinutes = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).minutes();
        let diffTotalEnd = diffEndHours + diffEndMinutes / 60;
        const globalStartDateTime = moment(
          getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.startTime.toString())
        ).toDate();
        const globalEndDateTime = moment(
          getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.finishTime.toString())
        ).toDate();
        const maxScheduleHrs = moment.duration(moment(globalEndDateTime, 'HH:mm').diff(moment(globalStartDateTime, 'HH:mm'))).asHours();
        if (ev.data.ScheduledHours > maxScheduleHrs && allUnallocateSectionID.some((el) => el === original.section_id)) {
          const tempResource = ev.section_id;
          scheduler.confirm({
            text: `Job would finish after workshop resource finishes for the day. You can press 'SPLIT' to split the job or click OK to reduce the schedule time to fit the end of the day`,
            title: 'Alert',
            ok: 'OK',
            cancel: 'SPLIT',
            callback: function (result) {
              if (result) {
                ev.start_date = globalStartDateTime;
                ev.end_date = globalEndDateTime;
                context.newScheduledHrs = maxScheduleHrs;
                ev.data['ScheduledHours'] = context.newScheduledHrs;
                context.updateOrder(ev, tempResource, context);
              } else {
                context.splitOrder(ev?.data?.JobID);
                return;
              }
            },
          });
          return false;
        } else if (diffTotalStart < 0 || diffTotalEnd > 0) {
          if (diffTotalStart < 0) {
            ev.start_date = globalStartDateTime;
            context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
            ev.data['ScheduledHours'] = context.newScheduledHrs;
            return true;
          } else if (diffTotalEnd > 0) {
            ev.end_date = globalEndDateTime;
            context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
            ev.data['ScheduledHours'] = context.newScheduledHrs;
            return true;
          }
        }
        context.newScheduledHrs = scheduler.getScheduledHrs(ev.start_date, ev.end_date);

        condition = this.btn_eventDropped(ev, original, technicianData, origionalTechnicianData);

        for (let i = 0; i < condition.length; i++) {
          if (allUnallocateSectionID.some((el) => el === original.section_id)) {
            if (condition[i]?.mins && condition[i]?.break > 0) {
              if (
                ev.start_date.toLocaleTimeString('it-IT') > condition[i]?.breakStartTime &&
                ev.start_date.toLocaleTimeString('it-IT') < condition[i]?.breakEndTime
              ) {
                let exceedMins =
                  condition[i]?.mins + (timeToMinutes(condition[i]?.breakStartTime) - timeToMinutes(ev.start_date.toLocaleTimeString('it-IT')));
                ev.end_date = moment(ev.end_date).add(exceedMins, 'm').toDate();
              } else {
                ev.end_date = moment(ev.end_date).add(condition[i]?.mins, 'm').toDate();
              }
              if (ev.start_date.toLocaleTimeString('it-IT') >= condition[i]?.breakStartTime) {
                ev.start_date.setHours(Number(condition[i]?.breakEndTime.toString().split(':')[0]) * 1);
                ev.start_date.setMinutes(Number(condition[i]?.breakEndTime.toString().split(':')[1]) * 1);
              }
            }
          } else {
            if (condition[i]?.value === 'droppedToBreak') {
              if (allUnallocateSectionID.some((el) => el === original.section_id)) {
                if (
                  ev.start_date.toLocaleTimeString('it-IT') > condition[i]?.breakStartTime &&
                  ev.start_date.toLocaleTimeString('it-IT') < condition[i]?.breakEndTime
                ) {
                  let exceedMins =
                    condition[i]?.mins + (timeToMinutes(condition[i]?.breakStartTime) - timeToMinutes(ev.start_date.toLocaleTimeString('it-IT')));
                  ev.end_date = moment(ev.end_date).add(exceedMins, 'm').toDate();
                } else {
                  ev.end_date = moment(ev.end_date).add(condition[i]?.mins, 'm').toDate();
                }
                if (ev.start_date.toLocaleTimeString('it-IT') >= condition[i]?.breakStartTime) {
                  ev.start_date.setHours(Number(condition[i]?.breakEndTime.toString().split(':')[0]) * 1);
                  ev.start_date.setMinutes(Number(condition[i]?.breakEndTime.toString().split(':')[1]) * 1);
                }
              } else {
                ev.end_date = moment(ev.end_date)
                  .add(condition[i]?.mins ?? 0, 'm')
                  .toDate();
                // If condition not empty and has breakStartTime property and condition[0] breakStartTime earlier that current event start time set event start time to break end time
                if (condition[i] && condition[i]?.breakStartTime && ev.start_date.toLocaleTimeString('it-IT') >= condition[i]?.breakStartTime) {
                  const startTime = moment(ev.start_date.toLocaleTimeString('it-IT'), 'HH:mm');
                  const breakStart = moment(condition[0]?.breakStartTime, 'HH:mm');
                  const minsToSubtract = breakStart.diff(startTime, 'minutes') || 0;
                  ev.end_date = moment(ev.end_date).add(minsToSubtract, 'minutes').toDate();
                  ev.start_date.setHours(Number(condition[i]?.breakStartTime.toString().split(':')[0]) * 1);
                  ev.start_date.setMinutes(Number(condition[i]?.breakStartTime.toString().split(':')[1]) * 1);
                }
                this.newScheduledHrs = context.newScheduledHrs + (condition[i].mins / 60) * -1;
              }
              scheduler.updateEvent(ev.id);
            } else if (condition[i]?.value === 'removeFromBreak') {
              // when moving from on break
              if (allUnallocateSectionID.some((el) => el === original.section_id)) {
                ev.end_date = moment(ev.end_date)
                  .add(condition[i]?.mins * condition[i]?.break, 'm')
                  .toDate();
                context.newScheduledHrs = context.newScheduledHrs - condition[i].mins / 60;
              } else {
                context.newScheduledHrs = context.newScheduledHrs - condition[i].mins / 60;
                //pbi- 4797
                // if (ev.data?.StandardFitHours) {
                //   ev.end_date.setHours(ev.start_date.getHours() + Math.floor(ev.data?.StandardFitHours)); // for 1 hour lunch break
                //   ev.end_date.setMinutes(ev.start_date.getMinutes() + (ev.data?.StandardFitHours - Math.floor(ev.data?.StandardFitHours)) * 60);
                // } else {
                ev.end_date = moment(ev.end_date)
                  .subtract(condition[i]?.mins ?? 0, 'minutes')
                  .toDate();
                //}
              }
              scheduler.updateEvent(ev.id);
            } else if (condition[i]?.value === 'NoDropOrRemoveBreak' && allUnallocateSectionID.some((el) => el === original.section_id)) {
              ev.end_date.setHours(ev.start_date.getHours() + Math.floor(ev.data?.StandardFitHours));
              ev.end_date.setMinutes(ev.start_date.getMinutes() + (ev.data?.StandardFitHours - Math.floor(ev.data?.StandardFitHours)) * 60);
              condition[0].value = this.btn_eventDropped(ev, original, technicianData, origionalTechnicianData);
              if (condition[0].value === 1) {
                ev.end_date.setHours(ev.end_date.getHours() + 1); // for 1 hour lunch break
                scheduler.updateEvent(ev.id);
              }
            } else if (condition[i]?.value === 'NoDropOrRemoveBreak') {
              context.newScheduledHrs = context.newScheduledHrs + (condition[i].mins / 60) * -1;
              if (ev.start_date.toLocaleTimeString('it-IT') >= condition[i]?.breakStartTime) {
                if (
                  ev.start_date.toLocaleTimeString('it-IT') > condition[i]?.breakStartTime &&
                  ev.start_date.toLocaleTimeString('it-IT') < condition[i]?.breakEndTime
                ) {
                  ev.end_date = moment(ev.end_date)
                    .subtract(timeToMinutes(ev.start_date.toLocaleTimeString('it-IT')) - timeToMinutes(condition[i]?.breakStartTime), 'm')
                    .toDate();
                }
                ev.start_date.setHours(Number(condition[i]?.breakEndTime.toString().split(':')[0]) * 1);
                ev.start_date.setMinutes(Number(condition[i]?.breakEndTime.toString().split(':')[1]) * 1);
              }
              if (
                ev.end_date.toLocaleTimeString('it-IT') > condition[i]?.breakStartTime &&
                ev.end_date.toLocaleTimeString('it-IT') <= condition[i]?.breakEndTime
              ) {
                ev.end_date = moment(ev.end_date).subtract(condition[i]?.mins, 'm').toDate();
              }
            }
          }
        }
        // after increament break hrs, check current endtime still falls between breaks
        let break1StartTime = getformatedTime((technicianData?.break1StartTime > 0 ? technicianData?.break1StartTime : 0).toString());
        let break1EndTime = getformatedTime((technicianData?.break1EndTime > 0 ? technicianData?.break1EndTime : 0).toString());
        let break2StartTime = getformatedTime((technicianData?.break2StartTime > 0 ? technicianData?.break2StartTime : 0).toString());
        let break2EndTime = getformatedTime((technicianData?.break2EndTime > 0 ? technicianData?.break2EndTime : 0).toString());
        let break3StartTime = getformatedTime((technicianData?.break3StartTime > 0 ? technicianData?.break3StartTime : 0).toString());
        let break3EndTime = getformatedTime((technicianData?.break3EndTime > 0 ? technicianData?.break3EndTime : 0).toString());

        if (ev.end_date.toLocaleTimeString('it-IT') > break1StartTime && ev.end_date.toLocaleTimeString('it-IT') < break1EndTime) {
          const breakhrs = moment.duration(moment(break2EndTime, 'HH:mm:ss').diff(moment(break2StartTime, 'HH:mm:ss'))).asHours();
          ev.end_date = moment(ev.end_date).add(breakhrs, 'hours').toDate();
        } else if (ev.end_date.toLocaleTimeString('it-IT') > break2StartTime && ev.end_date.toLocaleTimeString('it-IT') < break2EndTime) {
          const breakhrs = moment.duration(moment(break2EndTime, 'HH:mm:ss').diff(moment(break2StartTime, 'HH:mm:ss'))).asHours();
          ev.end_date = moment(ev.end_date).add(breakhrs, 'hours').toDate();
        } else if (ev.end_date.toLocaleTimeString('it-IT') > break3StartTime && ev.end_date.toLocaleTimeString('it-IT') < break3EndTime) {
          const breakhrs = moment.duration(moment(break3EndTime, 'HH:mm:ss').diff(moment(break3StartTime, 'HH:mm:ss'))).asHours();
          ev.end_date = moment(ev.end_date).add(breakhrs, 'hours').toDate();
        }
        // }

        if (original?.data?.ResourceAssigned.length > 1) {
          for (let i = 0; i < original?.data?.ResourceAssigned.length; i++) {
            customCheckCollision = scheduler.checkCollisionCustom(ev.start_date, ev.end_date, original?.data?.ResourceAssigned[i].ResourceID);
            if (customCheckCollision) {
              scheduler.alert({
                text: 'Techinican is already booked for selected date and time.',
                title: 'ERROR!',
                ok: 'OK',
                callback: function () {},
              });
              return false;
            } else return true;
          }
        }
      } else if (is_new && !allUnallocateSectionID.some((el) => el === ev.section_id)) {
        const condition = this.btn_newEventDropped(ev, technicianData);
        if (condition?.length > 0) {
          for (let i = 0; i < condition.length; i++) {
            if (condition[i]?.value === 'droppedToBreak') {
              this.scheduledHours = context.newScheduledHrs + (condition[i].mins / 60) * -1;
              context.newScheduledHrs = context.newScheduledHrs + (condition[i].mins / 60) * -1;
              scheduler.updateEvent(ev.id);
            }
          }
        } else {
          const selectedStartTime = moment(ev.start_date).format('HH:mm');
          const startRangeTime = moment(getformatedTime(technicianData.startTime.toString()), 'HH:mm');
          let diffStartHours = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).hours();
          let diffStartMinutes = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).minutes();
          let diffTotalStart = diffStartHours + diffStartMinutes / 60;

          const selectedEndTime = moment(ev.end_date).format('HH:mm');
          const endRangeTime = moment(getformatedTime(technicianData.finishTime.toString()), 'HH:mm');
          let diffEndHours = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).hours();
          let diffEndMinutes = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).minutes();
          let diffTotalEnd = diffEndHours + diffEndMinutes / 60;
          const globalStartDateTime = moment(
            getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.startTime.toString())
          ).toDate();
          const globalEndDateTime = moment(
            getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.finishTime.toString())
          ).toDate();
          if (diffTotalStart < 0) {
            ev.start_date = globalStartDateTime;
            context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
          } else if (diffTotalEnd > 0) {
            ev.end_date = globalEndDateTime;
            context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
          }
        }
        return true;
      }

      if ((is_new && allUnallocateSectionID.some((el) => el === ev.section_id)) || (is_new && ev.data?.OrderNumber)) {
        scheduler.config.dblclick_create = false;
        return false;
      } else if (!is_new && allUnallocateSectionID.some((el) => el === ev.section_id && ev.keyCode)) {
        scheduler.config.dblclick_create = false;

        scheduler.confirm({
          text: 'Dropping the task outside of the technician grid will delete the task, are you sure you want to delete the task?',
          title: 'Alert',
          ok: 'OK',
          cancel: 'CANCEL',
          callback: function (result: boolean) {
            if (result) {
              scheduler.deleteEvent(ev.id);
              //reload the scheduler data
              context.reloadRecords();
              return true;
            } else {
              return false;
            }
          },
        });
      } else {
        const endTime = moment(ev.end_date).format('HH:mm:ss').replace(/:|_/g, '')
        const startTime = moment(ev.start_date).format('HH:mm:ss').replace(/:|_/g, '');
        if(endTime > context.globalEnd || startTime < context.globalStart){
          if(startTime < context.globalStart){
            ev.start_date = moment(
              getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.startTime.toString())
            ).toDate()
          }
          if(endTime > context.globalEnd){
             ev.end_date = moment(
              getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(technicianData.finishTime.toString())
            ).toDate()
          }
       
        }
        return true;
      }
    });

    scheduler.attachEvent('onAfterLightbox', function () {
      scheduler.setNavStatus(false);
    });

    //-----------------------------------------------------------------------------
    //onContextMenu /Right Click
    //hide the calander
    //add menu div for right click
    //on scroll hide the menu
    //if right click without id return false
    //if right click on task return false
    //remove current menu div if on right click to different order
    //---------------------------------------------------------------------------
    scheduler.attachEvent('onContextMenu', function (id, e) {
      if (!id) {
        return;
      }
      let tooltip = scheduler.ext.tooltips.tooltip;
      if (tooltip) {
        tooltip.hide();
      }
      const screenHeight = document.documentElement.scrollHeight;
      const screenWidth = document.documentElement.scrollWidth;
      const positionCursorY = screenHeight - e.clientY < 210 ? e.clientY - (210 - (screenHeight - e.clientY)) : e.clientY;
      const positionCursorX = screenWidth - e.clientX < 200 ? e.clientX - (200 - (screenWidth - e.clientX)) : e.clientX;
      context.showingContextMenu = true;
      scheduler.removeContextMenu();
      let section = scheduler.matrix.timeline.y_unit[scheduler._locate_cell_timeline(e).y];
      if (scheduler._locate_cell_timeline(e)) {
        if (scheduler._locate_cell_timeline(e).x === -1) {
          if (context.technician.some((el) => el.resourceID === section.key)) {
            scheduler.setNavStatus(true);
            document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
            const contextMenu = `
              <div 
                style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background:white; padding-bottom:30px; width:200px"
                class='custom_menu'
                onclick="scheduler.removeContextMenu()"
              >
                <div style='display:flex; flex-direction:column; text-align:center'>
                  <input type=button value="Delete" onclick=""/ > 
                  <input type=button value="Edit" onclick=""/ > 
                </div>
                <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
                CANCEL
                </div>
              </div>
           `;
            //this.scheduler.tooltip.hide();
            const el = document.createElement('div');
            el.innerHTML = contextMenu;
            document.body.appendChild(el);
          }
        }
      }
      const ev = scheduler.getEvent(id);
      if (!ev?.keyCode && section.label === '') {
        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
        const order = ev.data.OrderType.toString();
        let listOrderMenu = '';
        for (let i = 0; i < context.listWorkshopVehicleStatus?.length; i++) {
          if (ev.data?.VehicleStatusCode !== context?.listWorkshopVehicleStatus[i]?.code) {
            listOrderMenu =
              listOrderMenu +
              `<input type=button value="` +
              context.listWorkshopVehicleStatus[i]?.shortDescription +
              `" 
            onclick="scheduler.customUpdateOrder({},${id},${context.listWorkshopVehicleStatus[i]?.code.toString()})"/>`;
          }
        }
        const contextMenu = `
          <div 
            style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background-color:transparent; padding-bottom:30px; width:200px"
            class='custom_menu'
            onclick="scheduler.removeContextMenu()"
          >
            <div style='display:flex; flex-direction:column; text-align:center; background:grey;'>
              Update Order
              ${listOrderMenu}
              <input type=button value="Split" onclick="scheduler.customSplitOrder(${ev?.data.JobID})"/>
             ${
               ev?.data?.OtherScheduledSplitsYN === 'Y' && ev?.data?.OtherUnScheduledSplitsYN === 'N'
                 ? `<input type=button value="Consolidate Including Scheduled" onclick="scheduler.forceUnallocateTF(${ev?.data.JobID})"/>`
                 : ev?.data?.OtherScheduledSplitsYN === 'Y' && ev?.data?.OtherUnScheduledSplitsYN === 'Y'
                 ? `<input type=button value="Consolidate Including Scheduled" onclick="scheduler.forceUnallocateTF(${ev?.data.JobID})"/>
                 <input type=button value="Consolidate Excluding Scheduled" onclick="scheduler.customConsolidateOrder(${ev?.data.JobID})"/>`
                 : ev?.data?.OtherUnScheduledSplitsYN === 'Y'
                 ? `<input type=button value="Consolidate" onclick="scheduler.customConsolidateOrder(${ev?.data.JobID})"/>`
                 : ''
             }
             ${
               ev?.data?.ValidSO === 'N'
                 ? `</div>
            <input type=button value="DELETE" 
            onclick="scheduler.customUpdateOrder({},${id},'DELETE')"/>`
                 : ``
             }
            <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
            CANCEL
            </div>
          </div>
       `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      } else if (!ev?.keyCode) {
        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');

        let list = '';
        for (let i = 0; i < context.listWorkshopVehicleStatus?.length; i++) {
          if (ev.data?.VehicleStatusCode !== context?.listWorkshopVehicleStatus[i]?.code) {
            list =
              list +
              `<input type=button value="` +
              context.listWorkshopVehicleStatus[i]?.shortDescription +
              `" 
            onclick="scheduler.customUpdateOrder({},${id},${context.listWorkshopVehicleStatus[i]?.code})"/>`;
          }
        }
        const contextMenu = `
          <div 
            style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background:white; background-color:transparent, padding-bottom:10px"
            class='custom_menu'
            onclick="scheduler.removeContextMenu()"
          >
            <div style='display:flex; flex-direction:column; text-align:center; background:grey;  padding-top:10px'>
              Update Status 
           ${list}
            
            </div>  
           
            <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
            CANCEL
            </div>
          </div>
       `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      } else if (ev?.keyCode) {
        const positionCursorY = screenHeight - e.clientY < 150 ? e.clientY - (150 - (screenHeight - e.clientY)) : e.clientY;
        const positionCursorX = screenWidth - e.clientX < 200 ? e.clientX - (200 - (screenWidth - e.clientX)) : e.clientX;

        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
        const contextMenu = `
        <div 
        style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background-color:transparent; padding-bottom:30px; width:200px"
        class='custom_menu'
        onclick="scheduler.removeContextMenu()"
      >
        <div style='display:flex; flex-direction:column; text-align:center; background:grey;'>
          Update Task
          <input type=button value="Delete Task" onclick="scheduler.customCreateOrUpdateEvent({},${id},'delete')"/>
         
        </div>
        <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
        CANCEL
        </div>
      </div>
       `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      }
    });
    scheduler.attachEvent('onAfterFolderToggle', function (section, isOpen, allSections) {
      if (section?.key === schedulerAppValue.unAllocatedFloater_SectionId) {
        if (isOpen) {
          context.floaterToggleState = true;
        } else {
          context.floaterToggleState = false;
        }
      }
      if (section?.key === schedulerAppValue.unAllocatedSalesOrder_SectionId) {
        if (isOpen) {
          context.salesTogglestate = true;
        } else {
          context.salesTogglestate = false;
        }
      }
    });
  }
  addCustomWorkshopSchedulerEvent(context: any) {
    context.customFunctionLoaded = true;
    const element = document.querySelector('.dhx_cal_data');
    element.addEventListener('scroll', (event) => {
      scheduler.removeContextMenu();
    });
    scheduler.btn_Clicked_onBeforeViewChange = (old_date, date) => {
      const old_datef = old_date?.toLocaleDateString('it-IT');
      const datef = date?.toLocaleDateString('it-IT');
      this.currentMonth = date.getMonth() + 1;
      if (old_date && old_datef !== datef) {
        scheduler.clearAll();
        const date1 = moment(new Date(moment(old_datef, 'DD/MM/YYYY').format('MM/DD/YYYY')));
        const date2 = moment(new Date(moment(datef, 'DD/MM/YYYY').format('MM/DD/YYYY')));
        if (moment(new Date()).isBefore(date2)) {
          this.showSMS = true;
        } else {
          this.showSMS = false;
        }
        if (Math.abs(moment.duration(date1.diff(date2)).asDays()) > 1) {
          this.forwardDirection = true;
          this.loadTimelineScheduler(datef);
          this.currentDate = datef;
          context.previousDate = datef;
          this.year = Number(this.currentDate.split('/')[2]);
          this.month = Number(this.currentDate.split('/')[1]);
          this.day = Number(this.currentDate.split('/')[0]);
        } else if (old_date > date) {
          this.forwardDirection = false;
          this.loadTimelineScheduler(context.previousGlobalDate);
          this.currentDate = context.previousGlobalDate;
          context.previousDate = old_datef;
          this.year = Number(this.currentDate.split('/')[2]);
          this.month = Number(this.currentDate.split('/')[1]);
          this.day = Number(this.currentDate.split('/')[0]);
        } else {
          this.forwardDirection = true;
          this.loadTimelineScheduler(context.nextGlobalDate);
          this.currentDate = context.nextGlobalDate;
          context.previousDate = old_datef;
          this.year = Number(this.currentDate.split('/')[2]);
          this.month = Number(this.currentDate.split('/')[1]);
          this.day = Number(this.currentDate.split('/')[0]);
        }
      }
    };

    scheduler.btn_splitOrder = (jobID) => {
      this.splitOrder(jobID);
    };

    scheduler.btn_consolidateOrder = (jobID) => {
      this.consolidateOrder(jobID, false);
    };
    scheduler.btn_currentEventData = (data: any) => {
      this.currentEventData = data;
    };

    scheduler.btn_openOrderDetailCard = (data: any) => {
      if (!this.orderDetailCardLoaded) {
        this.orderDetailCardLoaded = true;
        this.currentEventData = data;
        context.orderDetailCard();
      }
    };
    scheduler.btn_openTaskDetailCard = (data: any) => {
      if (!this.taskDetailCardLoaded) {
        this.taskDetailCardLoaded = true;
        this.currentTaskData = data;
        context.taskDetailCard();
      }
    };
    scheduler.btn_orderNumberClick = (data) => {
      this.fetchOrderFromJDE();
    };
    scheduler.getTechnician = () => {
      return context.technician;
    };
    scheduler.getOtherResources = () => {
      return context.otherResources;
    };
    scheduler.getScheduledHrs = (start, end) => {
      return moment.duration(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))).asHours();
    };

    //dp. api action
    scheduler.customCreateOrUpdateEvent = (data, id, state) => {
      if (id > 0 && state === 'delete') {
        const ev = scheduler.getEvent(id);
        const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID !== ev?.section_id).map((data) => {
          return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
        });
        const eventDataToUpdate = {
          branch: context.defaultBranch,
          jobID: ev?.data?.JobID,
          scheduledHours: ev?.data?.ScheduledHours,
          description: ev?.data.TaskDescription,
          resources: resourceList,
          startTime: ev?.data?.WorkshopStartTime,
          endTime: ev?.data?.WorkshopEndTime,
          startDate: ev?.data?.WorkshopStartDate,
          endDate: ev?.data?.WorkshopEndDate,
          taskCode: ev?.keyCode,
        };
        this.eventService.update(eventDataToUpdate).then((data) => {
          if (data) {
            context.reloadRecords();
          }
        });
      } else {
        this.eventService.insert(data).then((val) => {
          context.reloadRecords();
          return val;
        });
      }
    };
    scheduler.customDeleteEvent = (id, data) => {
      this.eventService.remove(data);
    };

    scheduler.customUpdateOrder = (data = {}, id = 0, state) => {
      if (id > 0) {
        const ev = scheduler.getEvent(id);
        if (state === 'DELETE') {
          scheduler.confirm({
            text: 'This action will delete this job permamently from scheduler. Are you sure?',
            ok: 'Yes',
            cancel: 'No',
            callback: function (result) {
              if (result) {
                context.removeOrderFromSchedule(ev?.data?.JobID).then((data) => {
                  if (data) {
                    context.reloadRecords();
                  }
                });
              } else {
              }
            },
          });
        } else if (state === 'UNALLOCATE') {
          const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID !== ev?.section_id).map((data) => {
            return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: ev?.data?.ScheduledHours,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: ev?.data?.WorkshopStartTime,
            endTime: ev?.data?.WorkshopEndTime,
            startDate: ev?.data?.WorkshopStartDate,
            endDate: ev?.data?.WorkshopEndDate,
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: ev?.data?.VehicleStatusCode,
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              context.reloadRecords();
            }
          });
        } else if (state === 'SCHEDULE_FOR_TOMORROW') {
          const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID === ev?.section_id).map((data) => {
            return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: 0,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: 0,
            endTime: 0,
            startDate: context.nextGlobalDate,
            endDate: context.nextGlobalDate,
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: ev?.data?.VehicleStatusCode,
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              context.reloadRecords();
            }
          });
        } else {
          const resourceList = ev?.data?.ResourceAssigned.map((el) => {
            return { resourceID: el.ResourceID, allocationTypeCode: el.AllocationTypeCode, allocationPercentage: el.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: ev.data?.ScheduledHours,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: ev?.data?.WorkshopStartTime,
            endTime: ev?.data?.WorkshopEndTime,
            startDate: ev?.data?.WorkshopStartDate,
            endDate: ev?.data?.WorkshopEndDate,
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: state === 0 ? '00' : state?.toString(),
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          if (state === 10) {
            this.sendSMSReminder(false, ev?.data?.JobID, orderDataToUpdate);
          } else if (state === 30) {
            this.sendSMSCollectCar(ev?.data?.JobID, orderDataToUpdate);
          } else {
            this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
              if (data) {
                context.reloadRecords();
              }
            });
          }
        }
      } else {
        this.eventService.maintainOrderBooking(data).then((data) => {
          if (data) {
            context.reloadRecords();
          }
        });
      }
    };

    scheduler.customSplitOrder = (jobID) => {
      this.splitOrder(jobID);
    };
    scheduler.customConsolidateOrder = (jobID) => {
      this.consolidateOrder(jobID, false);
    };
    scheduler.forceUnallocateTF = (jobID) => {
      scheduler.confirm({
        title: 'Confirm',
        text: 'Are you sure you want to remove from the schedule existing order splits and consolidate them into this unallocated order?',
        ok: 'Ok',
        cancel: 'Cancel',
        callback: function (result) {
          if (result) {
            context.consolidateOrder(jobID, true);
          }
        },
      });
    };

    scheduler.setNavStatus = (value) => {
      this.eventService.navDisable = value;
    };

    scheduler.removeContextMenu = () => {
      const el = document.querySelector('.custom_menu');
      if (el) {
        el.innerHTML = null;
        el.remove();
        scheduler.setNavStatus(false);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:');
      }
    };

    scheduler.showSpinner = () => {
      if (scheduler.config.show_loading) {
        let spin;
        spin = document.createElement('div');
        spin.className = 'dhx_loading';
        spin.style.left = Math.round((scheduler._x - 128) / 2) + 'px';
        spin.style.top = Math.round((scheduler._y - 15) / 2) + 'px';
        scheduler._obj.appendChild(spin);
      }
    };

    scheduler.hideSpinner = () => {
      let spin = document.createElement('div');
      if (spin && typeof spin == 'object') {
        if (spin.parentNode) {
          spin?.parentNode?.removeChild(spin);
        }
        scheduler.config.show_loading = true;
      }
    };

    scheduler.btn_eventDropped = (ev, original, technicianData, origionalTechnicianData) => {
      return checkInBreakRange(ev, original, technicianData, origionalTechnicianData);
    };

    scheduler.btn_newEventDropped = (ev, technicanData) => {
      return breaksFallBetweenEvent(ev, technicanData);
    };

    scheduler.getResourceList = (resoureList, previousTechnicianIDData) => {
      previousTechnicianIDData;
      const filteredTechnician = previousTechnicianIDData?.data?.ResourceAssigned.filter((el) => {
        return el.ResourceID !== previousTechnicianIDData.section_id;
      });

      let resource = resoureList.map((el) => {
        return { resourceID: el, allocationTypeCode: '', allocationPercentage: 100 };
      });
      filteredTechnician
        ? filteredTechnician?.map((el) =>
            resource.push({ resourceID: el?.ResourceID, allocationTypeCode: el.AllocationTypeCode, allocationPercentage: el.AllocationPercentage })
          )
        : null;
      return resource;
    };

    scheduler.checkCollisionCustom = (startDate, endDate, resourceId) => {
      let count = scheduler.getEvents(startDate, endDate);
      let evsWithSamePerson = count.filter((item) => item.section_id === resourceId);
      if (evsWithSamePerson.length > 1) {
        return true;
      } else {
        return false;
      }
    };

    scheduler.getBarBackgroundColourCode = (statusGroup, code, scheduledTF) => {
      return context.listWorkshopOrderStatus?.filter((el) => el?.statusGroup === statusGroup?.toString() && el?.code === code)[0]
        ?.backgroundColourCode;
    };
    scheduler.confimationDeleteOrder = (dataToDelete) => {
      context.eventService
        .removeResourceFromSchedule(dataToDelete)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data) {
            scheduler.alert({
              text: 'Deleted',
              title: 'Message',
              ok: 'OK',
            });
            scheduler.clearAll();
            context.loadTimelineScheduler(context.currentDate);
          }
        });
    };
    scheduler.customReloadAll = () => {
      scheduler.clearAll();
      context.loadTimelineScheduler(context.currentDate);
    };
    scheduler.showSectionTooltipTechnician = (index, text) => {
      context.showTooltip(index, text);
    };

    scheduler.hideSectionTooltipTechnician = (index) => {
      context.hideTooltip(index);
    };

    scheduler.showSectionTooltipOtherResource = (index, text) => {
      context.showTooltipOtherResource(index, text);
    };

    scheduler.hideSectionTooltipOtherResource = (index) => {
      context.hideTooltipOtherResource(index);
    };
  }
  addworkshopSchedulerTemplates(context) {
    scheduler.config.tooltip_hide_timeout = 10;
    scheduler.templates.tooltip_text = function (start, end, event) {
      if (context.showingContextMenu) {
        return;
      }
      const splitJobText = event?.data?.JobSplitText ? '<b>Split Job:</b> ' + event?.data?.JobSplitText + '<br/>' : '';
      const eventText = event?.text ? '<b>Task:</b> ' + event?.text : '';
      const eventCustomer = event.data?.CustomerName ? '<br/><b>Customer:</b> ' + event.data?.CustomerName : '';
      const billedHours = event.data?.StandardFitHours ? '<br/><b>Billed Fit Hours:</b> ' + event.data?.StandardFitHours : '';
      const scheduledHours = event.data?.ScheduledHours ? '<br/><b>Scheduled Hours:</b> ' + event.data?.ScheduledHours : '';
      const vehicleStatus = event.data?.VehicleStatus ? '<br/><b>Vehicle Status:</b> ' + event.data?.VehicleStatus : '';
      const jobType = event.data?.JobType ? '<br/><b>Job Type:</b> ' + event.data?.JobType : '';
      const warningMsg = event.data?.ValidSO === 'N' ? "<br/><span style='color:red'><b>Warning:</b> No open fit lines remaining</span>" : '';
      const date =
        allUnallocateSectionID.some((el) => el === event.section_id) === false
          ? '<br/><b>Start:</b> ' + start.toLocaleTimeString('it-IT') + '<br/><b>End:</b> ' + end.toLocaleTimeString('it-IT')
          : '';

      return splitJobText + eventText + eventCustomer + billedHours + scheduledHours + vehicleStatus + jobType + date + warningMsg;
    };
  }
  addTechnicianToTimeline() {
    // Sort resourceList by surname (assumed to be the second word in resourceName)
    this.resourceList = this.resourceList?.slice().sort((a, b) => {
      const getSurname = (name: string) => {
        const parts = name?.trim().split(' ');
        return (parts && parts.length > 1 ? parts[parts.length - 1] : '').toLowerCase();
      };
      const aSurname = getSurname(a.resourceName);
      const bSurname = getSurname(b.resourceName);
      return aSurname.localeCompare(bSurname);
    });

    this.technician = this.resourceList
      ?.filter((el) => el.genericResourceTF === false)
      .map(function (el, index) {
        let obj = Object.assign({}, el);
        const description = (el.resourceDesc1 ? `Desc 1: ${el.resourceDesc1}` : '') + (el.resourceDesc2 ? `\n Desc 2:  ${el.resourceDesc2}` : '');

        obj.key = el.resourceID;
        obj.label = `<div style="display:flex; row">${el.resourceName}
         ${
           el.resourceDesc1 || el.resourceDesc2
             ? `<div title='${description}' style="margin-left:auto;">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0V0z" fill="none"/>
          <path d="M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"/>
          </svg>
        </div>`
             : ''
         }
       
                    </div>

                  
        
        `;

        return obj;
      });
    this.otherResources = this.resourceList
      ?.filter((el) => el.genericResourceTF === true)
      .map(function (el, index) {
        let obj = Object.assign({}, el);
        if (el.genericResourceTF) {
          const description = (el.resourceDesc1 ? `Desc 1: ${el.resourceDesc1}` : '') + (el.resourceDesc2 ? `\n Desc 2:  ${el.resourceDesc2}` : '');
          obj.key = el.resourceID;
          obj.label = `<div style="display:flex; row">
            ${
              !el.includeInBillableHoursTF
                ? `<div title='Resource not included in available hours'
             >
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="m798-270-60-60q11-27 16.5-52.5T760-436q0-116-82-200t-198-84q-28 0-54 4.5T374-700l-60-60q38-20 79.5-30t86.5-10q74 0 139.5 28T734-694.5Q783-645 811.5-579T840-436q0 45-11 86.5T798-270Zm52-370L680-810l56-56 170 170-56 56ZM820-24 694-150q-45 33-99.5 51.5T480-80q-74 0-139.5-28T226-184q-49-48-77.5-113T120-436q0-62 18.5-116.5T192-652l-34-34-48 48-56-56 48-48-74-74 56-56L876-80l-56 56ZM480-159q42 0 82-13t74-36L248-594q-23 35-35.5 75.5T200-436q0 116 82 196.5T480-159Zm-38-242Zm114-114Z"/></svg>
                </div>`
                : ''
            }
        ${el.resourceName}
         ${
           el.resourceDesc1 || el.resourceDesc2
             ? `<div title='${description}' >
          <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0V0z" fill="none"/>
          <path d="M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"/>
          </svg>
        </div>`
             : ''
         }
        </div>
        `;
        }
        return obj;
      });

    scheduler.updateCollection('sections', this.getSection(this.technician));
  }
  addMarkedTimespan() {
    const globalStartInMinutes = getformatedTimeForZones(this.globalStart.toString());
    const globalEndInMinutes = getformatedTimeForZones(this.globalEnd.toString());
    this.resourceList.map((el) => {
      const startTime = getformatedTimeForZones(el.startTime.toString());
      const finishTime = getformatedTimeForZones(el.finishTime.toString());
      const break1StartTime = getformatedTimeForZones(el.break1StartTime.toString());
      const break1EndTime = getformatedTimeForZones(el.break1EndTime.toString());
      const break2StartTime = getformatedTimeForZones(el.break2StartTime.toString());
      const break2EndTime = getformatedTimeForZones(el.break2EndTime.toString());
      const break3StartTime = getformatedTimeForZones(el.break3StartTime.toString());
      const break3EndTime = getformatedTimeForZones(el.break3EndTime.toString());
      scheduler.addMarkedTimespan({
        days: 'fullweek',
        zones: [break1StartTime, break1EndTime],
        css: 'green_section_short_break',
        sections: { timeline: el.resourceID },
        html: `${el.break1Name.toUpperCase()}`,
      });
      scheduler.addMarkedTimespan({
        days: 'fullweek',
        zones: [break2StartTime, break2EndTime],
        css: 'green_section_lunch_break',
        sections: { timeline: el.resourceID },
        html: `${el.break2Name.toUpperCase()}`,
      });
      scheduler.addMarkedTimespan({
        days: 'fullweek',
        zones: [break3StartTime, break3EndTime],
        css: 'green_section_short_break',
        sections: { timeline: el.resourceID },
        html: `${el.break3Name.toUpperCase()}`,
      });
      //blocks events from workshop start till resource allocated start time  and also block from resource finished Time workshop finish time
      scheduler.addMarkedTimespan({
        days: 'fullweek',
        zones: [globalStartInMinutes, startTime, finishTime, globalEndInMinutes],
        css: 'fat_lines_section',
        sections: { timeline: el.resourceID },
        type: 'dhx_time_block', //the hardcoded value
      });
    });
  }
  addTaskToTimeline() {
    this.taskArray?.map((allocatedTasks, index) => {
      const colorEvent = getEventColorFromListWorkshopTask(allocatedTasks?.TaskCode, this.listWorkshopTasks);
      const startDateTime = getformatedDate(allocatedTasks?.WorkshopStartDate) + ' ' + getformatedTime(allocatedTasks?.WorkshopStartTime.toString());
      const endDateTime = getformatedDate(allocatedTasks?.WorkshopEndDate) + ' ' + getformatedTime(allocatedTasks?.WorkshopEndTime.toString());
      allocatedTasks.ResourceAssigned.map((el) => {
        scheduler.parse([
          {
            start_date: startDateTime,
            end_date: endDateTime,
            text: allocatedTasks?.TaskDescription,
            data: allocatedTasks,
            keyCode: allocatedTasks?.TaskCode,
            section_id: el.ResourceID,
            color: colorEvent,
            listWorkshopTask: this.listWorkshopTasks,
          },
        ]);
      });
    });
  }
  addOrderToTimeline(globalStartTime: string) {
    this.orderArray
      ?.filter((el) => el.ResourceAssigned.length > 0)
      .map((allocatedOrders) => {
        const startDateTime =
          getformatedDate(allocatedOrders?.WorkshopStartDate) + ' ' + getformatedTime(allocatedOrders?.WorkshopStartTime.toString());
        const endDateTime = getformatedDate(allocatedOrders?.WorkshopEndDate) + ' ' + getformatedTime(allocatedOrders?.WorkshopEndTime.toString());
        allocatedOrders.ResourceAssigned?.map((el, index) => {
          index % 2 === 0
            ? scheduler.parse([
                {
                  start_date: startDateTime,
                  end_date: endDateTime,
                  text: allocatedOrders?.Description,
                  data: allocatedOrders,
                  section_id: el.ResourceID,
                },
              ])
            : scheduler.parse([
                {
                  start_date: startDateTime,
                  end_date: endDateTime,
                  text: allocatedOrders?.Description,
                  data: allocatedOrders,
                  section_id: el.ResourceID,
                },
              ]);
        });
      });
    const unnallocatedOrders = this.orderArray?.filter((el) => el.ResourceAssigned.length < 1);
    const filteredSalesOrders = unnallocatedOrders?.filter((el) => el?.StatusGroup === 'SALES ORDER').sort();
    const filteredOrdersFloater = unnallocatedOrders?.filter((el) => el?.StatusGroup === 'FLOATER').sort();
    const endRangeTime = moment(getformatedTime(this.globalEnd.toString()), 'HH:mm');

    for (let i = 0; i < filteredSalesOrders?.length; i++) {
      const totalInMinutes = filteredSalesOrders[i]?.ScheduledHours * 60 > 30 ? filteredSalesOrders[i]?.ScheduledHours * 60 : 30;
      const startTime = getformatedTime(globalStartTime.toString());
      const endTime = moment(startTime, 'HH:mm:ss').add(totalInMinutes, 'minutes').format('HH:mm:ss');
      const startDateTime = getformatedDate(this.currentDate) + ' ' + startTime;
      let endDateTime = (getformatedDate(this.currentDate) + ' ' + endTime).toString();
      if (endRangeTime.isBefore(moment(startTime, 'HH:mm').add(totalInMinutes, 'minutes'))) {
        endDateTime = (getformatedDate(this.currentDate) + ' ' + endRangeTime.format('HH:mm')).toString();
      }
      scheduler.parse([
        {
          start_date: startDateTime,
          end_date: endDateTime,
          text: filteredSalesOrders[i]?.Description,
          data: filteredSalesOrders[i],
          section_id: schedulerAppValue.unAllocatedSalesOrder_SectionId_child,
          filteredSalesOrdersSize: filteredSalesOrders.length,
          listWorkshopJobType: this.listWorkshopJobTypes,
        },
      ]);
      // }
    }
    for (let i = 0; i < filteredOrdersFloater?.length; i++) {
      const totalInMinutes = filteredOrdersFloater[i]?.ScheduledHours * 60 > 30 ? filteredOrdersFloater[i]?.ScheduledHours * 60 : 30;
      const startTime = getformatedTime(globalStartTime.toString());
      const endTime = moment(startTime, 'HH:mm:ss').add(totalInMinutes, 'minutes').format('HH:mm');
      const startDateTime = getformatedDate(this.currentDate) + ' ' + startTime;
      let endDateTime = (getformatedDate(this.currentDate) + ' ' + endTime).toString();
      if (endRangeTime.isBefore(moment(startTime, 'HH:mm').add(totalInMinutes, 'minutes'))) {
        endDateTime = (getformatedDate(this.currentDate) + ' ' + endRangeTime.format('HH:mm')).toString();
      }
      scheduler.parse([
        {
          start_date: startDateTime,
          end_date: endDateTime,
          text: filteredOrdersFloater[i]?.Description,
          data: filteredOrdersFloater[i],
          section_id: schedulerAppValue.unAllocatedFloater_SectionId_child,
          filteredOrdersFloaterSize: filteredOrdersFloater.length,
          listWorkshopJobType: this.listWorkshopJobTypes,
        },
      ]);
      //}
    }
  }
  getSection(technician: any) {
    scheduler.updateCollection('technician', this.technician);
    scheduler.updateCollection('otherResources', this.otherResources);
    const unnallocatedOrders = this.orderArray?.filter((el) => el.ResourceAssigned.length < 1);
    const unnallocatedOrdersSize = this.orderArray?.filter((el) => el.ResourceAssigned.length < 1).length ?? 0;
    const unallocatedOrderNormalLabel = unnallocatedOrders?.filter((el) => el?.StatusGroup === 'SALES ORDER').sort().length ?? 0;
    const unallocatedOrderFitLabel = unnallocatedOrders?.filter((el) => el?.StatusGroup === 'FLOATER').sort().length ?? 0;

    let elements = [
      // original hierarhical array to display
      {
        key: schedulerAppValue.unAllocatedOrder_Master_SectionId,

        label: 'UNALLOCATED ORDERS' + '(' + unnallocatedOrdersSize + ')',
        open: true,
        children: [
          {
            key: schedulerAppValue.unAllocatedSalesOrder_SectionId,
            label: 'Sales Orders ' + '(' + unallocatedOrderNormalLabel + ')',
            open: this.salesTogglestate,
            children: [{ key: schedulerAppValue.unAllocatedSalesOrder_SectionId_child, label: '', children: [] }],
          },
          {
            key: schedulerAppValue.unAllocatedFloater_SectionId,
            label: 'Floaters ' + '(' + unallocatedOrderFitLabel + ')',
            open: this.floaterToggleState,
            children: [{ key: schedulerAppValue.unAllocatedFloater_SectionId_child, label: '', children: [] }],
          },
        ],
      },
      {
        key: schedulerAppValue.technician_SectionId,
        label: technician.length > 0 ? `4X4 Technician` : '(No Technician found)',
        open: true,
        children: technician,
      },
      {
        key: schedulerAppValue.otherResource_SectionID,
        label: technician.length > 0 ? `OTHER RESOURCES` : '(No other Resources found)',
        open: true,
        children: this.otherResources,
      },
    ];

    return elements;
  }
  removeContextMenu() {
    const el = document.querySelector('.context_menu');
    if (el) {
      el.innerHTML = null;
      el.remove();
    }
  }
  reloadRecords() {
    this.loadingSubject.next(true);
    scheduler.clearAll();
    this.fetchRecords().then((data: any) => {
      if (data) {
        this.taskArray = data?.taskArray;
        this.orderArray = data?.orderArray;
        this.addTechnicianToTimeline();
        this.addOrderToTimeline(this.globalStart);
        this.addTaskToTimeline();
        this.loadingSubject.next(false);
      }
    });
  }
  //event on openModelBox
  resourceAdd() {
    this.eventService
      .fetchResourceListV2({
        branch: this.defaultBranch,
        date: this.currentDate,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
          modalRef.componentInstance.actionAddResource = true;
          modalRef.componentInstance.availableResources = data?.resourceList;
          modalRef.componentInstance.globalData = this.globalData;
          modalRef.componentInstance.defaultBranch = this.defaultBranch;
          modalRef.componentInstance.currentDate = this.currentDate;
          modalRef?.result.then((result) => {
            if (result) {
              scheduler.customReloadAll();
            }
          });
        }
      });
  }
  setWorkshopDay() {
    const modalRef = this.modalService.open(SchedulerSetWorkshopDays, { size: 'xl' });
    modalRef.componentInstance.actionSetWorkshopDay = true;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.customReloadAll();
      }
    });
  }

  setWorkshopHour() {
    const modalRef = this.modalService.open(SchedulerSetWorkshopHours, { size: 'xl' });
    modalRef.componentInstance.actionSetWorkshopDay = true;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.customReloadAll();
      }
    });
  }
  resourceChange() {
    const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
    modalRef.componentInstance.actionChangeResource = true;
    modalRef.componentInstance.resourceList = this.resourceList;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.clearAll();
        this.loadTimelineScheduler(this.currentDate);
      }
    });
  }
  resourceRemove() {
    this.eventService
      .fetchScheduledResources({
        branch: this.defaultBranch,
        startDate: convert(scheduler.getState().date),
        endDate: convert(scheduler.getState().date),
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
          modalRef.componentInstance.actionRemoveResource = true;
          modalRef.componentInstance.resourceList = data?.resourceList;
          modalRef.componentInstance.currentDate = this.currentDate;
          modalRef.componentInstance.defaultBranch = this.defaultBranch;
          modalRef?.result.then((resultData) => {
            if (resultData) {
              if (resultData?.confirmationRequired) {
                scheduler.confirm({
                  text: `${resultData?.message}`,
                  title: 'Alert',
                  ok: 'CONFIRM',
                  cancel: 'CANCEL',
                  callback: function (result) {
                    if (result) {
                      Object.assign(resultData.dataToRemoveResource, { confirmedTF: true });
                      scheduler.confimationDeleteOrder(resultData.dataToRemoveResource);
                    }
                  },
                });
              } else {
                scheduler.customReloadAll();
              }
            }
          });
        }
      });
  }

  setWorkshopHours() {} //TODO: implement UI and function
  setWorkshopDays() {} //TODO: implement UI and function
  //service call
  fetchWorkshopTaskList() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopTask({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  fetchWorkshopJobType() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopJobTypes({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  fetchWorkshopHours(date: string) {
    return new Promise((resolve) => {
      this.eventService
        .fetchWorkshopHours({
          branch: this.defaultBranch,
          startDate: date,
          endDate: date,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  fetchRecords() {
    return new Promise((resolve) => {
      this.eventService
        .fetchRecordsForBooking({
          startDate: this.currentDate,
          endDate: this.currentDate,
          branch: this.defaultBranch,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  splitOrder(jobID) {
    const selectedOrder = this.orderArray.filter((el) => el.JobID === jobID)[0];
    this.eventService
      .fetchOrderDetailsForSplit({
        jobID: jobID,
        autoSplitTF: false,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          if (data?.response?.jobGroup) {
            const modalRef2 = this.modalService.open(SplitOrderContent, { size: 'xl', backdrop: 'static' });
            modalRef2.componentInstance.actionSplitOrder = true;
            modalRef2.componentInstance.unAssignedOrdersList = data?.response?.jobGroup;
            modalRef2.componentInstance.orginalUnAssignedOrdersList = data?.response?.jobGroup;
            modalRef2.componentInstance.selectedOrder = selectedOrder;
            modalRef2.componentInstance.currentDate = this.currentDate;
            modalRef2.componentInstance.defaultBranch = this.defaultBranch;
            modalRef2?.result.then((result) => {
              if (result) {
                scheduler.clearAll();
                this.loadTimelineScheduler(this.currentDate);
              }
            });
          } else {
            scheduler.alert({
              text: 'Cannot perform split',
              title: 'Split Invalid',
              ok: 'Ok',
            });
          }
        }
      });
  }

  consolidateOrder(jobID, forceUnallocateTF) {
    this.eventService
      .consolidateOrderV2({
        jobID: jobID,
        forceUnallocateTF: forceUnallocateTF,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          scheduler.clearAll();
          this.reloadRecords();
        }
      });
  }
  fetchOrderFromJDE() {
    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: this.currentEventData?.data?.OrderNumber.toString(),
        orderType: this.currentEventData?.data?.OrderType,
        JDEOrderType: this.currentEventData?.data?.JDEOrderType,
        JDECompany: this.currentEventData?.data?.JDECompany,
      })
    );
  }
  getListWorkshopVehicleStatus() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopVehicleStatus({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  getListWorkshopJobTypes() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopJobTypes({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  searchOrders() {
    if (this.searchOrderForm.value.orderNumber?.length > 2) {
      this.eventService
        .findSalesOrderInSchedule({
          orderNumber: this.searchOrderForm.value.orderNumber.toString(),
          branch: this.defaultBranch,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data?.ErrorFlag === '0') {
            scheduler.clearAll();
            this.loadTimelineScheduler(data?.ScheduleDate);
            this.searchOrderStatus = true;
          }
        });
    }
  }
  updateOrder(ev, tempResource, context) {
    const resourceList = context.resourceList
      .filter((el) => el.resourceID === tempResource)
      .map((data) => {
        return {
          resourceID: data.resourceID,
          allocationTypeCode: '',
          allocationPercentage: 100,
        };
      });
    const orderDataToUpdate = {
      branch: context.defaultBranch,
      jobID: ev?.data?.JobID,
      status: Number(ev?.data?.Status),
      scheduledHours: ev.data?.ScheduledHours,
      orderNumber: ev?.data?.OrderNumber,
      orderType: ev?.data?.OrderType,
      description: ev?.data.Description,
      resources: resourceList,
      startTime: Number(moment(ev?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
      endTime: Number(moment(ev?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
      startDate: context.currentDate,
      endDate: context.currentDate,
    };
    context.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
      if (data) {
        context.reloadRecords();
      }
    });
  }

  sendSMSReminder(sendtoAll = false, jobID = 0, orderDataToUpdate) {
    this.confirmationService.confirm({
      message: sendtoAll
        ? 'You are about to send a SMS message to all customers with jobs scheduled to a technican for this date where the vehicle is not already on site. <div style="text-align:center"><p>ARE YOU SURE?</p></div>'
        : 'You are about to send a SMS message to customers',
      key: 'sendSMSConfirmation',
      accept: () => {
        this.eventService
          .sendSMSReminderBeforeBooking({ date: sendtoAll ? this.currentDate : '', jobID: sendtoAll ? 0 : jobID })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '1' && data?.resultArray.length > 0) {
              let error = '';
              this.confirmationService.confirm({
                message: data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
            } else if (data?.ErrorFlag === '0') {
              this.confirmationService.confirm({
                message: 'Message sent successfully',
                key: 'sendSMSResult',
                accept: () => {},
              });
              this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
                if (data) {
                  this.reloadRecords();
                }
              });
            }
          });
      },
    });
  }
  sendSMSCollectCar(jobID = 0, orderDataToUpdate) {
    this.confirmationService.confirm({
      message: 'You are about to send collect car SMS message to customer',
      key: 'sendSMSConfirmation',
      accept: () => {
        this.eventService
          .sendSMSCollectCar({ jobID: jobID })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '1') {
              let error = '';
              this.confirmationService.confirm({
                message: data?.Message ?? data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
            } else if (data?.ErrorFlag === '0') {
              let error = '';
              this.confirmationService.confirm({
                message: data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
              this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
                if (data) {
                  this.reloadRecords();
                }
              });
            }
          });
      },
    });
  }
  legendView() {
    if (!this.vehicleStatusLegend) {
      this.eventService
        .listWorkshopLegend({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          this.vehicleStatusLegend = data?.SearchResults.filter((el) => el.group === 'VEHICLE STATUS');
          this.jobTypeLegend = data?.SearchResults.filter((el) => el.group === 'JOB TYPE');
          this.customerTypeLegend = data?.SearchResults.filter((el) => el.group === 'CUSTOMER TYPE');
          this.modalService.open(this.modalBox, { size: 'lg', backdrop: 'static' });
        });
    } else {
      this.modalService.open(this.modalBox, { size: 'lg', backdrop: 'static' });
    }
  }
  handleCloseModal(event) {
    if (event) {
      this.modalService.dismissAll();
    }
  }

  orderDetailCard() {
    const modalRef = this.modalService.open(NgbdModalOrderDetailCard, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.actionOrderDetailCard = true;
    modalRef.componentInstance.resourceList = this.resourceList;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef.componentInstance.currentEventData = this.currentEventData?.data;
    modalRef.componentInstance.brandDefaultsPhoneDigits = this.brandDefaults?.phoneDigits;
    modalRef.componentInstance.jobTypeList = this.listWorkshopJobTypes;
    modalRef.componentInstance.allocated = this.currentEventData?.data?.ResourceAssigned?.length > 0 ? true : false;
    modalRef?.result.then((result) => {
      if (result) {
        this.orderDetailCardLoaded = false;
        const resourceListSet = new Set(this.currentEventData?.data?.ResourceAssigned?.map((item) => item.ResourceID));
        const uniqueTechnicianList = result?.technicianResource?.filter((item) => !resourceListSet.has(item.resourceID));
        const uniqueOtherList = result?.otherResource?.filter((item) => !resourceListSet.has(item.resourceID));
        uniqueTechnicianList?.map((el) => {
          scheduler.addEventNow({
            start_date: this.currentEventData?.start_date,
            end_date: this.currentEventData?.end_date,
            text: this.currentEventData?.text,
            section_id: el.resourceID,
          });
        });
        uniqueOtherList?.map((el) => {
          scheduler.addEventNow({
            start_date: this.currentEventData?.start_date,
            end_date: this.currentEventData?.end_date,
            text: this.currentEventData?.text,
            section_id: el.resourceID,
          });
        });
        if (!this.isEventCollision) {
          const resourceListToUpdate = result?.technicianResource.map((data) => {
            return {
              resourceID: data.resourceID,
              allocationTypeCode: '',
              allocationPercentage: 100,
            };
          });
          if (result?.otherResource.length > 0) {
            const otherResourceToUpdate = result?.otherResource.map((data) => {
              return {
                resourceID: data.resourceID,
                allocationTypeCode: '',
                allocationPercentage: 100,
              };
            });
            otherResourceToUpdate.map((el) => resourceListToUpdate.push(el));
          }
          const orderDataToUpdate = {
            branch: this.defaultBranch,
            jobID: this.currentEventData?.data?.JobID,
            scheduledHours: this.currentEventData?.data?.ScheduledHours,
            orderNumber: this.currentEventData?.data?.OrderNumber,
            orderType: this.currentEventData?.data?.OrderType,
            description: result?.jobDescription,
            resources: resourceListToUpdate,
            startTime: this.currentEventData?.data?.WorkshopStartTime,
            endTime: this.currentEventData?.data?.WorkshopEndTime,
            startDate: result?.fitDate,
            endDate: result?.fitDate,
            jobTypeCode: result?.jobTypeCode,
            vehicleStatusCode: this.currentEventData?.data?.VehicleStatusCode ?? '00',
            jobOwner: result?.jobOwner ?? '',
            customerPhone: result?.customerPhone,
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              this.orderDetailCardLoaded = false;
              this.reloadRecords();
            }
          });
        } else {
          this.showCollisionAlert();
        }
      } else {
        this.orderDetailCardLoaded = false;
      }
    });
  }

  taskDetailCard() {
    this.currentTaskData = this.currentTaskData ? this.currentTaskData : this.searchOrderStatus ? this.currentEventData : '';
    this.currentTaskData['data'] = this.currentTaskData?.data ? this.currentTaskData?.data : this.currentTaskData;
    const modalRef = this.modalService.open(NgbdModalTaskDetailCard, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.actionTaskDetailCard = true;
    modalRef.componentInstance.resourceList = this.resourceList;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef.componentInstance.jobTypeList = this.listWorkshopTasks;
    modalRef.componentInstance.currentTaskData = this.currentTaskData;
    modalRef.componentInstance.brandDefaults = this.brandDefaults;

    modalRef?.result.then((result) => {
      if (result) {
        const resourceListSet = new Set(result?.currentTaskData?.ResourceAssigned?.map((item) => item.ResourceID));
        let uniqueTechnicianList = result?.technicianResource?.filter((item) => !resourceListSet.has(item.resourceID));
        let uniqueOtherList = result?.otherResource?.filter((item) => !resourceListSet.has(item.resourceID));
        if (result?.isNewEvent) {
          uniqueTechnicianList = uniqueTechnicianList.filter((el) => el.resourceID !== this.currentTaskData?.section_id);
          uniqueOtherList = uniqueOtherList.filter((el) => el.resourceID !== this.currentTaskData?.section_id);
        }
        uniqueTechnicianList?.map((el) => {
          if (!this.isEventCollision) {
            scheduler.addEventNow({
              start_date: this.currentTaskData?.start_date,
              end_date: this.currentTaskData?.end_date,
              text: this.currentTaskData?.text,
              section_id: el.resourceID,
            });
          }
        });

        uniqueOtherList.map((el, index) => {
          if (!this.isEventCollision) {
            scheduler.addEventNow({
              start_date: this.currentTaskData?.start_date,
              end_date: this.currentTaskData?.end_date,
              text: this.currentTaskData?.text,
              section_id: el.resourceID,
            });
          }
        });
        if (!this.isEventCollision) {
          const resourceListToUpdate = result?.technicianResource.map((data) => {
            return {
              resourceID: data.resourceID,
              allocationTypeCode: '',
              allocationPercentage: 100,
            };
          });
          if (result?.otherResource.length > 0) {
            const otherResourceToUpdate = result?.otherResource.map((data) => {
              return {
                resourceID: data.resourceID,
                allocationTypeCode: '',
                allocationPercentage: 100,
              };
            });
            otherResourceToUpdate.map((el) => resourceListToUpdate.push(el));
          }

          const eventDataToCreateOrUpdate = {
            startDate: this.currentDate,
            endDate: this.currentDate,
            startTime: Number(moment(this.currentTaskData?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(this.currentTaskData?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            branch: this.defaultBranch,
            jobID: result?.isNewEvent ? 0 : result?.currentTaskData?.JobID,
            taskCode: result.jobTypeCode,
            description: result?.jobDescription,
            scheduledHours: result.scheduledHours,
            resources: resourceListToUpdate,
            jobOwner: result?.isNewEvent ? '' : result?.currentTaskData?.JobOwner,
          };

          this.eventService.update(eventDataToCreateOrUpdate).then((data) => {
            if (data) {
              this.reloadRecords();
              this.taskDetailCardLoaded = false;
            }
          });
        } else {
          this.showCollisionAlert();
        }
      } else {
        this.taskDetailCardLoaded = false;
        this.cancelReload();
      }
    });
  }

  cancelReload() {
    scheduler.clearAll();
    this.addTechnicianToTimeline();
    this.addOrderToTimeline(this.globalStart);
    this.addTaskToTimeline();
  }
  showCollisionAlert() {
    scheduler.alert({
      text: 'Currently selected techinican(s) is already booked for selected date and time.',
      title: 'ERROR!',
      ok: 'OK',
    });
    this.cancelReload();
    this.taskDetailCardLoaded = false;
    this.orderDetailCardLoaded = false;
    this.isEventCollision = false;
  }

  ngOnDestroy() {
    scheduler.destructor();
  }
  showTooltip(id, text) {
    let tooltip = document.getElementById('tooltip' + id);
    tooltip.style.marginTop = '-65px';
    tooltip.innerHTML = text;
    tooltip.style.visibility = 'visible';
  }
  hideTooltip(id) {
    document.getElementById('tooltip' + id).style.visibility = 'hidden';
  }
  showTooltipOtherResource(id, text) {
    let tooltip = document.getElementById('tooltipOtherResource' + id);
    tooltip.style.marginTop = '-65px';
    tooltip.innerHTML = text;
    tooltip.style.visibility = 'visible';
  }
  hideTooltipOtherResource(id) {
    document.getElementById('tooltipOtherResource' + id).style.visibility = 'hidden';
  }
  setCalendarNavButton(previous, next) {
    //dhx_cal_prev_button dhx_cal_next_button
    if (!previous) {
      document.querySelector('.dhx_cal_prev_button')?.setAttribute('style', 'visibility:hidden');
      document.querySelector('.dhx_cal_prev_button')?.setAttribute('style', 'pointer-events:none');
    } else {
      document.querySelector('.dhx_cal_prev_button')?.setAttribute('style', 'visibility:show');
      document.querySelector('.dhx_cal_prev_button')?.setAttribute('style', 'pointer-events:auto');
    }
    if (!next) {
      document.querySelector('.dhx_cal_next_button')?.setAttribute('style', 'pointer-events:none');
      document.querySelector('.dhx_cal_next_button')?.setAttribute('style', 'visibility:hidden');
    } else {
      document.querySelector('.dhx_cal_next_button')?.setAttribute('style', 'visibility:show');
      document.querySelector('.dhx_cal_next_button')?.setAttribute('style', 'pointer-events:atuo');
    }
  }

  goToDate(d: NgbDateStruct) {
    let date: any;
    let month: any;
    if (d.day?.toString().length < 2) {
      date = '0' + d.day.toString();
    } else {
      date = d.day.toString();
    }
    if (d.month.toString().length < 2) {
      month = '0' + d.month.toString();
    } else {
      month = d.month.toString();
    }
    const day = date + '/' + month + '/' + d.year.toString();
    this.loadTimelineScheduler(day);
  }

  goToWeekView() {
    this.router.navigate(['/pos/scheduler/' + this.currentDate + '/week']);
  }

  checkIfShowOrdeDetails() {
    if (this.searchOrderStatus) {
      const foundOrder = this.orderArray?.find((el) => el.JobID === Number(this.searchOrderForm.value.jobId));
      if (foundOrder) {
        this.currentEventData = { data: foundOrder };
        this.orderDetailCard();
      } else {
        const foundTask = this.taskArray?.find((el) => el.JobID === Number(this.searchOrderForm.value.jobId));
        if (foundTask) {
          this.currentEventData = { data: foundTask };
          this.taskDetailCard();
        }
      }
    }
    this.searchOrderStatus = false;
  }
  removeOrderFromSchedule(jobId) {
    this.loadingSubject.next(true);
    this.eventService
      .removeOrderFromSchedule({
        jobID: jobId,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.loadingSubject.next(false);
        if (data?.ErrorFlag === '0') {
          scheduler.clearAll();
          this.reloadRecords();
        }
      });
  }

  // Calendar Event Handlers
  onCalendarDateSelected(date: NgbDateStruct) {
    this.goToDate(date);
  }

  onCalendarMonthNavigated(event: any) {
    this.currentMonth = event?.next?.month;
  }

  onCalendarOpened(event: any) {
    //get current month from currentDate
        
    this.currentMonth = moment(this.currentDate).month() + 1;

  }

  onJobOrderSelected(jobOrder: JobOrder) {
    //this.currentEventData = jobOrder;
    this.searchOrderForm.patchValue({ orderNumber: jobOrder?.orderNumber.toString(), jobId: jobOrder?.jobID });
    scheduler.clearAll();
    if (this.orderArray?.some((el) => el.JobID === jobOrder?.jobID) || this.taskArray?.some((el) => el.JobID === jobOrder?.jobID)) {
      this.loadTimelineScheduler(jobOrder?.fitDate);
    } else {
      this.loadTimelineScheduler(jobOrder?.fitDate);
    }
    this.searchOrderStatus = true;
  }


}

